import "./AppSearch.css";

type AppSearchProps = {
    
}

export const AppSearch = ({} : AppSearchProps) => {
    return (
        <>
            <div className="app-search">
                <input 
                    type="text"
                    placeholder="Search"
                    className="app-search-input"
                />
            </div>
        </>
    )

}